<template>
    <div class="box">
        <img class="activity-bg" src="../../../../static/model-bg3.jpg" alt="">
        <div class="activity-content">
              <div >充<span>{{materialParamsDTO.materialParamsDetailDTOList[0].rechargeMoney}}</span>多送<span>{{materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMoney}}</span></div>
      <p>共得{{materialParamsDTO.materialParamsDetailDTOList[0].totalbookCoin}}书币</p>
      <span v-if="status==2"  @click="goTopay">立即领取</span>
      <span v-if="status==1" class="default-btn">活动尚未开始</span>
      <span v-if="status==0" class="default-btn">活动已下线</span>
      <span v-if="status==3" class="default-btn">活动已结束</span>
            <!-- <span  :class="status!=2?'default-btn':''" @click="goTopay">立即充值</span> -->
              <div class="activity-tip">
            <p>活动规则</p>
            <p>1、活动时间：即日起至<span v-if="endTime">{{endTime}}</span></p>
      <p>2、本次活动
        <span v-if="purchaseLimitDTO.purchaseLimitType==2">参与次数不限</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==1">每天仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==0">每人仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
      </p>
            <p>3、此充值为书币充值，一经充值不支持退款</p>
        </div>
        </div>
      

    </div>
</template>
<script>
export default {
      props:['status','materialParamsDTO','endTime','purchaseLimitDTO'],
  data() {
    return {
    };
  },
  watch:{
    materialParamsDTO:{
        handler: function (val) {
         console.log(val)
        },
        deep: true
    },
    purchaseLimitDTO:{
       handler: function (val) {
         console.log(val)
        },
        deep: true
    }
  },
  methods:{
    goTopay(){
      this.$emit('payActivity',this.materialParamsDTO.materialParamsDetailDTOList[0])
    }
  }
}
</script>
<style scoped>
.box{
    position: relative;
}
.activity-bg{
    width: 100%;
    display: block;
}
.activity-content{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top:calc(228px + env(safe-area-inset-top))

}
.activity-content>div{
    font-size: 25px;
color: #333333;
text-align: center;
/*  */
font-weight: bold;
}
.activity-content>div>span{
   color: #E31A0B;
}
.activity-content>p{
    text-align: center;
   color: #E31A0B;
    font-size: 20px;
    margin-top: 4px;
    margin-bottom: 14px;
}
.activity-content>span{
font-size: 20px;
color: #FFFFFF;
text-align: center;
width: 297px;
margin:0 auto;
display: block;
height: 55px;
line-height: 55px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
.activity-content>span.default-btn{
    background: #CFCFCF;
    font-size: 20px;
color: #636363;
}
.activity-content>.activity-tip{
    margin:0 auto;
    margin-top: 26px;
    text-align: left;
    width: 260PX;
}
.activity-tip p:nth-of-type(1){
    text-align: center;
     font-size: 14px;
    margin-bottom:6px;
}
.activity-tip p{
     white-space: nowrap;
    font-size: 12px;
color: #FFFFFF;
line-height: 17px;
    font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modelthree.vue